import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Satellite } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_6e894956-e0cf-436a-9bc1-acfe808956c7/artifacts/0kl4vee6_log%20att.png";

export const Footer = () => {
  return (
    <footer className="bg-slate-100 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800" data-testid="footer">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <img 
              src={LOGO_URL} 
              alt="FastFix Logo" 
              className="h-12 w-auto object-contain"
            />
            <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
              Especialistas em informática desde 2014. Soluções personalizadas em tecnologia com atendimento 100% online.
            </p>
            <div className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
              <span className="font-semibold">CNPJ:</span>
              <span>41.932.231/0001-10</span>
            </div>
            <p className="text-sm font-medium text-blue-600 dark:text-blue-400">
              Há mais de 10 anos no mercado
            </p>
          </div>

          {/* Links */}
          <div className="space-y-4">
            <h4 className="font-secondary font-semibold text-slate-900 dark:text-white">
              Links Rápidos
            </h4>
            <nav className="flex flex-col gap-2">
              <Link 
                to="/" 
                className="text-sm text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                data-testid="footer-link-produtos"
              >
                Produtos
              </Link>
              <Link 
                to="/starlink" 
                className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                data-testid="footer-link-starlink"
              >
                <Satellite className="w-4 h-4" />
                Aluguel Starlink Mini
              </Link>
              <Link 
                to="/sobre" 
                className="text-sm text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                data-testid="footer-link-sobre"
              >
                Sobre Nós
              </Link>
              <Link 
                to="/carrinho" 
                className="text-sm text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                data-testid="footer-link-carrinho"
              >
                Carrinho
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-secondary font-semibold text-slate-900 dark:text-white">
              Contato
            </h4>
            <div className="space-y-3">
              <a 
                href="https://wa.me/5591984849479"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sm text-slate-600 dark:text-slate-400 hover:text-green-600 dark:hover:text-green-400 transition-colors"
                data-testid="footer-whatsapp"
              >
                <Phone className="w-4 h-4" />
                (91) 98484-9479
              </a>
              <div className="flex items-start gap-3 text-sm text-slate-600 dark:text-slate-400">
                <MapPin className="w-4 h-4 mt-0.5" />
                <span>Atendimento 100% Online</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-slate-200 dark:border-slate-800">
          <p className="text-center text-sm text-slate-500 dark:text-slate-400">
            © {new Date().getFullYear()} FastFix. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
